import bonding from '@images/bonding.png'
import edmentum from '@images/edmentum.png'
import ratnasagar from '@images/ratnasagar.png'
import threePLearningLogoWhite from '@images/logos/3p-logo-white.svg'
import { PartnerCode } from 'teacher-ui-client/partner/partners'
import type PartnerService from 'teacher-ui-client/services/partner'
import { service } from '@ember/service'
import Component from '@glimmer/component'
import type { SubscriptionType } from 'teacher-ui-client/subscription-type/subscription-types'
import { t } from 'ember-intl'

interface PartnerData {
  website: string
  logo: string
}

const partnerDataMap: Partial<Record<PartnerCode, PartnerData>> = {
  [PartnerCode._3P]: {
    website: 'https://www.3plearning.com',
    logo: threePLearningLogoWhite,
  },
  [PartnerCode.RatnaSagar]: {
    website: 'https://www.ratnasagar.com',
    logo: ratnasagar,
  },
  [PartnerCode.Edmentum]: {
    website: 'https://www.edmentum.com',
    logo: edmentum,
  },
  [PartnerCode.Bonding]: {
    website: 'https://www.abceggs.co.kr',
    logo: bonding,
  },
}

interface Signature {
  subscriptionType: SubscriptionType
}

export class Partner extends Component<Signature> {
  @service partner!: PartnerService

  get partnerForSubscriptionType() {
    return this.partner.partnerForSubscriptionType(this.args.subscriptionType)
  }

  get partnerLogo() {
    return (this.partnerData?.logo ?? '').toString()
  }

  get partnerData() {
    const partnerCode = this.partnerForSubscriptionType?.code ?? PartnerCode._3P
    return partnerDataMap[partnerCode] ?? partnerDataMap[PartnerCode._3P]
  }

  <template>
    <a
      data-test-partner-link
      class="mt-1 inline-block"
      href={{this.partnerData.website}}
      target="_blank"
      rel="noopener noreferrer"
    >
      {{#if this.partnerData.logo}}
        <img src={{this.partnerLogo}} alt={{t "components.footerMain.imageLinks.partnerCompany"}} />
      {{/if}}
    </a>
  </template>
}

export default Partner
